/* Switching the scheduling plugin off, when there is a service mapping to lose.
 *
 * Only shown when something is actually stored — with nothing mapped the toggle
 * just turns off, because a modal that asks about nothing is noise. */
import * as Vue from 'vue';
import { store } from '../store.js';

export const PluginConfirm = {
  name: 'PluginConfirm',
  setup: function () {
    return {
      prompt: Vue.computed(function () { return store.ui.pluginPrompt; }),
      close: store.closePluginPrompt,
      confirm: store.confirmDisableScheduling
    };
  },
  template: [
    '<div v-if="prompt" class="modal-scrim" @click.self="close">',
    '  <div class="sheet" role="dialog" aria-modal="true">',
    '    <div class="sheet__head sheet__head--plain">',
    '      <div>',
    '        <h3>Turn off {{ prompt.name }}?</h3>',
    '        <p>The board keeps every turn already on it. It stops showing the day&rsquo;s book, the &ldquo;next&rdquo; clock on each name, and the checkout that stops turns on its own.</p>',
    '      </div>',
    '    </div>',
    '',
    '    <div class="assign__section">',
    '      <h4 class="assign__label">{{ prompt.mapped }} {{ prompt.mapped === 1 ? "service is" : "services are" }} mapped to a turn type</h4>',
    '      <p class="setting__hint">Keeping the mapping costs nothing and means switching {{ prompt.name }} back on restores every badge exactly as it is now. Discarding it deletes those rows for good &mdash; you would map them again from scratch.</p>',
    '    </div>',
    '',
    '    <div class="sheet__actions">',
    '      <button type="button" class="btn btn--quiet" @click="close">Cancel</button>',
    '      <button type="button" class="btn btn--danger-ghost" @click="confirm(true)">',
    '        Turn off and discard</button>',
    '      <button type="button" class="btn btn--primary" @click="confirm(false)">',
    '        Turn off and keep it</button>',
    '    </div>',
    '  </div>',
    '</div>'
  ].join('\n')
};
